import React from 'react';
import block from 'bem-cn-lite';
import {Text} from '@gravity-ui/uikit';
import {ArrowRight} from '@gravity-ui/icons';

import './LogoPriceInfo.scss';

const b = block('logo-price-info');

interface LogoPriceInfoProps {
    logoPrice: string;
    className?: string;
    visiblePriceListIdentifier?: string;
}

export const LogoPriceInfo: React.FC<LogoPriceInfoProps> = ({
    logoPrice,
    visiblePriceListIdentifier,
    className
}) => {
    const showVisibleIdentifier =
        Boolean(visiblePriceListIdentifier) && logoPrice.toUpperCase().includes('BERG');

    return (
        <div className={`${b('block', className)}`}>
            <div className={b('lines')}>
                <Text variant="body-1" className={b('text')}>
                    {logoPrice}
                </Text>
                {showVisibleIdentifier && (
                    <Text variant="caption-2" color="secondary" className={b('visible')}>
                        (<ArrowRight className={b('arrow')} />
                        {visiblePriceListIdentifier})
                    </Text>
                )}
            </div>
        </div>
    );
};
